<template>
    <v-autocomplete
        v-model="model"
        :items="products"
        :loading="isBusy"
        :search-input.sync="keywords"
        prepend-icon="mdi-magnify"
        :label="$t('shopping_cart.product')"
        :hint="$t('shopping_cart.start_typing_any_product_attribute')"
        item-value="id"
        item-text="id"
        class="mb-3"
        persistent-hint
        hide-no-data
        return-object
        clearable
        outlined
        dense
        no-filter
        @change="onSelectProduct"
    >
        <template v-slot:item="{ item }">
            <v-list-item-avatar tile>
                <v-img :src="item.image_url"/>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>
                    {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ item.model }}
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
                {{ item.in_stock }}
                {{ $t('products.pieces') }}
            </v-list-item-action>
        </template>
    </v-autocomplete>
</template>

<script>
import {API} from '@/api/api'
import ShoppingCartMixin from '@/mixins/ShoppingCartMixin'
import SnackbarMixin from "@/mixins/SnackbarMixin";
import _ from "lodash";

export default {
    name: "AddProductQuicklyComponent",
    mixins: [SnackbarMixin, ShoppingCartMixin],
    props: {
        userId: {
            type: Number,
            required: true
        },
        warehouseId: {
            type: Number,
            required: true
        },
        storeModule: {
            type: String,
            required: false,
            default: () => "shoppingCart"
        }
    },
    data: () => ({
        // loading
        isBusyProducts: 0,
        // autocomplete model
        model: null,
        // autocomplete value
        keywords: null,
        // data
        products: [],
        // autocomplete request counter
        requestCounter: 0
    }),
    watch: {
        keywords: _.debounce(function (keywords) {
            if (!keywords || keywords.length < 1) {
                this.products = [];
                return;
            }

            const url = "/api/warehouses/" + encodeURI(this.warehouseId) + "/products"
                + "?page=1"
                + "&perPage=100"
                + "&filter=" + encodeURI(keywords);

            let requestNumber = (this.requestCounter += 1);

            this.isBusyProducts += 1;
            API.get(url)
                .then(response => {
                    if (requestNumber === this.requestCounter) {
                        this.products = response.data;
                    }
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyProducts -= 1;
                });
        }, 250)
    },
    computed: {
        isBusy() {
            return this.isBusyProducts > 0;
        }
    },
    methods: {
        onSelectProduct() {
            if (!this.model) {
                return;
            }

            let count = this.getProductQuantity(this.userId, this.warehouseId, this.model.external_id, this.storeModule);
            count = count > 0 ? count : 1;
            this.addProductToShoppingCart(this.userId, this.warehouseId, this.model, count, this.storeModule);

            this.model = null;
            this.keywords = null;

            window.location.reload();
        }
    }
}
</script>
